import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TreeDialogComponent} from '../tree-dialog.component';
import {TreeDialogService} from '../service/tree-dialog.service';
import {OverlayModule} from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
  ],
  declarations: [TreeDialogComponent],
  providers: [TreeDialogService]
})
export class TreeDialogModule {
}
